/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetPrefecturesResponseAllOf,
    GetPrefecturesResponseAllOfFromJSON,
    GetPrefecturesResponseAllOfFromJSONTyped,
    GetPrefecturesResponseAllOfToJSON,
} from './GetPrefecturesResponseAllOf';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';
import {
    Prefecture,
    PrefectureFromJSON,
    PrefectureFromJSONTyped,
    PrefectureToJSON,
} from './Prefecture';

/**
 * 
 * @export
 * @interface GetPrefecturesResponse
 */
export interface GetPrefecturesResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetPrefecturesResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetPrefecturesResponse
     */
    message: string;
    /**
     * 
     * @type {Array<Prefecture>}
     * @memberof GetPrefecturesResponse
     */
    data: Array<Prefecture>;
}

export function GetPrefecturesResponseFromJSON(json: any): GetPrefecturesResponse {
    return GetPrefecturesResponseFromJSONTyped(json, false);
}

export function GetPrefecturesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPrefecturesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ((json['data'] as Array<any>).map(PrefectureFromJSON)),
    };
}

export function GetPrefecturesResponseToJSON(value?: GetPrefecturesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ((value.data as Array<any>).map(PrefectureToJSON)),
    };
}

